import AboutUs from "./AboutUs/AboutUs";
import Branches from "./Branches/Branches";
import Contact from "./Contact/Contact";
import CustomNavbar from "./CustomNavbar/CustomNavbar";
import Footer from "./Footer/Footer";
import Products from "./Products/Products";
import Hero from "./sections/Hero/Hero";
import { useRef } from "react";

const HomePage = () => {
  return (
    <>
      <CustomNavbar />
      <Hero />
      <AboutUs />
      <Products />
      <Branches />
      <Contact />
      <Footer />
    </>
  );
};
export default HomePage;
